/* global jQuery */

export default function GatedDownloads () {
    document.addEventListener('DOMContentLoaded', () => {
        const wrappers = document.querySelectorAll('.mtt-gated-downloads')
        if (wrappers.length > 0) {
            for (let i = 0; i < wrappers.length; i++) {
                const gatedDownload = new GatedDownload(wrappers[i])
                gatedDownload.init()
            }
        }
    })
}

class GatedDownload {
    fileId = ''
    fileName = ''

    wrapper
    useForSplitTest
    modal
    formId
    wpcf7

    constructor(wrapper) {
        this.wrapper = wrapper

        this.useForSplitTest = this.wrapper.hasAttribute('data-use-for-split-test')
        this.modalId = this.wrapper.getAttribute('data-modal-id')
        this.modal = this.wrapper.querySelector('[data-mtt-modal-id="' + this.modalId + '"]')
        this.formId = this.wrapper.getAttribute('data-form-id')
        this.wpcf7 = this.wrapper.querySelector('.wpcf7')
    }

    init() {
        this.addButtonClick()
        this.addModalClose()
        this.addFormFunctionality()
    }

    addButtonClick() {
        const downloadButtons = this.wrapper.querySelectorAll('.gated-modal-open')

        if (downloadButtons.length) {
            for (let i = 0; i < downloadButtons.length; i++) {
                const button = downloadButtons[i]

                button.addEventListener('click', () => {
                    this.fileId = button.getAttribute('file-id')
                    this.fileName = button.getAttribute('file-name')

                    if (this.modal !== null) {
                        const downloadedPageName = this.modal.querySelector('input[name="downloaded-page-name"]')
                        if (downloadedPageName !== null) {
                            downloadedPageName.value = document.title
                        }

                        const downloadedPdfName = this.modal.querySelector('input[name="downloaded-pdf-name"]')
                        if (downloadedPdfName !== null) {
                            downloadedPdfName.value = this.fileName
                        }

                        this.modal.classList.add('mtt-modal-wrap--open')
                    }

                    if (this.useForSplitTest) {
                        if (this.getGatedSplitTestValue() !== 'true') {
                            this.downloadFile()
                        }

                        return
                    }

                    if (this.modal === null) {
                        this.downloadFile()
                    } else {
                        this.modal.classList.add('mtt-modal-wrap--open')
                    }
                })
            }
        }
    }

    addModalClose() {
        const closeBtn = this.wrapper.querySelector('.mtt-modal__close')

        if (!closeBtn) {
            return
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal.classList.contains('mtt-modal-wrap--open')) {
                this.modal.classList.remove('mtt-modal-wrap--open')
            }
        })

        closeBtn.addEventListener('click', () => {
            this.modal.classList.remove('mtt-modal-wrap--open')
        })
    }

    addFormFunctionality() {
        if (this.wpcf7) {
            document.addEventListener('wpcf7mailsent', (event) => {
                if (this.formId == event.detail.contactFormId) {
                    this.downloadFile()
                    this.handleGatedSplitTestAfterSubmit()
                }
            }, false)
        }
    }

    downloadFile() {
        const data = {
            'action': 'gated_downloads',
            'fileId': this.fileId
        }

        jQuery.post(main_theme_objects.ajax_url, data, function (response) {
            if (response.fileAttachement) {
                const link = document.createElement("a")
                link.setAttribute('download', '')
                link.href = response.fileAttachement
                document.body.appendChild(link)
                link.click()
                link.remove()
            }
        })
    }

    getGatedSplitTestValue() {
        let gatedSplitTest = sessionStorage.getItem('gatedSplitTest')

        if (gatedSplitTest === null) {
            gatedSplitTest = Math.random() < 0.5 ? 'true' : 'false'
            sessionStorage.setItem('gatedSplitTest', gatedSplitTest)
        }

        return gatedSplitTest
    }

    handleGatedSplitTestAfterSubmit () {
        const gatedSplitTest = this.getGatedSplitTestValue()

        if (gatedSplitTest !== 'true') {
            return
        }

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            'event': 'pdf_modal_submit',
            'name': this.fileName
        })
    }
}